import React, {Component} from 'react';
import ChampionImage from '../utils/ChampionImage';
class MemberUnit extends Component{
    getName(unit) {
        if(unit.name.split('_')[1] === "TrainerDragon") {
            return "Nomsy"
        } else {
            return unit.name.split('_')[1]
        }
    }
    render() {
        if(this.props.units != null && this.props.units !== [] ){ 
            let unitsSlice = this.props.units.slice(0, 10);
            return(
                <div className='flex flex-col justify-items-start text-left'>
                    {unitsSlice.map((unit,index) => (
                        unit.total > 0 ? 
                        <div key={index} className={index % 2 ? 'bg-slate-200 flex flex-row' : 'flex flex-row'}>
                            <div className='basis-1/3 flex pl-2 leading-8'>{this.getName(unit)}</div>
                            <div className='basis-1/5 flex flex-col'>
                                <ChampionImage name={unit.name}/>        
                            </div>
                            <div className='flex flex-col'>
                                <div className='align-middle' style={{lineHeight: '29px'}}>x {unit.total}</div>
                            </div>    
                        </div>
                        : ''                        
                    ))}  
                </div>
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberUnit